


































import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { dateToPST, formatDate } from "@/lib/time";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import ListItem from "@/components/ListItem";
import { EarningReportData, EarningReportTypeStatDetails, StatField } from "../../types";
import StatementItemDetails from "../StatementItemDetails";

const SHORT_DATE: Partial<Intl.DateTimeFormatOptions> = { month: "short", day: "2-digit", year: "numeric" };

export default defineComponent({
  name: "StatementsItem",
  components: { FormatMoney, ListItem, StatementItemDetails, BaseIcon },
  props: {
    earningReportItem: { type: Object as () => EarningReportData, required: true },
    fields: { type: Array as () => StatField[], required: true },
    open: { type: Boolean, required: true },
  },
  setup(props) {
    const timeFrom = computed(() =>
      props.earningReportItem.timeFrom
        ? formatDate(dateToPST(new Date(props.earningReportItem.timeFrom)), SHORT_DATE)
        : ""
    );
    const timeTo = computed(() =>
      props.earningReportItem.timeTo ? formatDate(dateToPST(new Date(props.earningReportItem.timeTo)), SHORT_DATE) : ""
    );
    const totalDetails = computed(() => {
      const getTotal = (key: keyof EarningReportTypeStatDetails) =>
        props.fields.reduce((out, field) => out + props.earningReportItem.typeStats[field.key][key], 0);
      return {
        amount: getTotal("amount"),
        fee: getTotal("fee"),
        agentFee: getTotal("agentFee"),
        totalAmount: getTotal("totalAmount"),
      };
    });

    const title = computed(() =>
      timeFrom.value && timeTo.value ? `${timeFrom.value} - ${timeTo.value}` : $t("All time")
    );

    const setFocus = (el: Element) => {
      el.scrollIntoView({ block: "start", behavior: "smooth" });
    };

    return { timeFrom, timeTo, totalDetails, title, setFocus };
  },
});
